/* ja-snow.js: the template's snow.js, booted per <canvas class="ja-snow"> (announcement bar). Generated by
   tools/build_store.py; do not edit. */
(function () {
  "use strict";
  if (!("requestAnimationFrame" in window)) return;
  function boot(canvas) {
  var mql = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
  if (mql && mql.matches) return;
  var ctx = canvas.getContext("2d", { alpha: true });
  if (!ctx) return;
  var hero = canvas.parentElement;
  var colors = [canvas.dataset.color || "#ffffff"];
  if (canvas.dataset.color2) colors.push(canvas.dataset.color2);
  var density = Math.max(0.25, Math.min(3, parseFloat(canvas.dataset.density) || 1));
  var W = 0, H = 0, dpr = 1, flakes = [], raf = 0, last = 0, visible = true, active = true, started = false;

  function size() {
    var r = canvas.getBoundingClientRect();
    var w = Math.round(r.width), h = Math.round(r.height);
    if (!w || !h) return false;
    dpr = Math.min(2, window.devicePixelRatio || 1);
    if (w !== W || h !== H) {
      W = w; H = h;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
    }
    return true;
  }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function make(y) {
    var r = rand(1, 3.2), near = Math.random() < 0.15;
    if (near) r = rand(3, 4.2);
    return { x: rand(0, W), y: y == null ? rand(-20, H) : y, r: r, v: rand(20, 55) * (near ? 1.3 : 1), a: near ? rand(0.6, 0.85) : rand(0.35, 0.6),
             amp: rand(10, 25), per: rand(4, 7), ph: rand(0, Math.PI * 2), c: colors[Math.floor(Math.random() * colors.length)] };
  }
  function seed() {
    var n = Math.round((W < 750 ? 18 : 36) * density);
    flakes = [];
    for (var i = 0; i < n; i++) flakes.push(make());
  }
  function frame(t) {
    raf = 0;
    if (!active || !visible) return;
    var dt = last ? Math.min(0.05, (t - last) / 1000) : 0; // seconds, capped so a resumed tab does not jump
    last = t;
    var sec = t / 1000;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < flakes.length; i++) {
      var f = flakes[i];
      f.y += f.v * dt;
      var x = f.x + Math.sin(sec * (Math.PI * 2 / f.per) + f.ph) * f.amp;
      if (f.y - f.r > H) { flakes[i] = f = make(-f.r - rand(0, 20)); x = f.x; }
      ctx.globalAlpha = f.a;
      ctx.fillStyle = f.c;
      ctx.beginPath();
      ctx.arc(x, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    raf = requestAnimationFrame(frame);
  }
  function run() { if (!raf && active && visible && size()) { last = 0; raf = requestAnimationFrame(frame); } }
  function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

  function start() {
    if (started) return;
    started = true;
    if (!size()) return;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { visible = en.some(function (e) { return e.isIntersecting; }); if (visible) run(); else stop(); }, { threshold: 0 }).observe(hero);
    }
    document.addEventListener("visibilitychange", function () { active = document.visibilityState !== "hidden"; if (active) run(); else stop(); });
    var ro = "ResizeObserver" in window ? new ResizeObserver(function () { size(); }) : null;
    if (ro) ro.observe(canvas); else window.addEventListener("resize", function () { size(); });
    if (mql && mql.addEventListener) mql.addEventListener("change", function (e) { if (e.matches) { active = false; stop(); ctx.clearRect(0, 0, W, H); } else { active = !document.hidden; run(); } });
    run();
  }
  function whenIdle() { if ("requestIdleCallback" in window) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 800); }
  if (document.readyState === "complete") whenIdle(); else window.addEventListener("load", whenIdle, { once: true });
  }
  document.querySelectorAll("canvas.ja-snow").forEach(boot);
})();
